import React, { ReactNode } from 'react';
import { ConfigProvider } from 'antd';

type ThemeData = {
  borderRadius: number;
  colorPrimary: string;
  Button?: {
    colorPrimary: string;
    algorithm?: boolean;
  };
};

const coreTheme: ThemeData = {
  borderRadius: 2,
  colorPrimary: '#2c89c6',
};

interface StyleProviderProps {
  children: ReactNode;
}

export default function StyleProvider({ children }: StyleProviderProps) {
  return (
    <>
      <style>
        {`
          .compact-date-range-picker-popup .ant-picker-panel-container {
            max-height: min(78vh, 640px);
            overflow-y: auto;
          }

          .compact-date-range-picker-popup .ant-picker-panels {
            padding: 4px;
          }

          .compact-date-range-picker-popup .ant-picker-footer {
            padding: 4px 8px;
          }

          .compact-date-range-picker-popup .ant-form-item {
            margin-bottom: 0;
          }

          @media (max-height: 900px) {
            .compact-date-range-picker-popup .ant-picker-panel-container {
              max-height: min(74vh, 560px);
            }

            .compact-date-range-picker-popup .ant-picker-panels {
              padding: 2px;
            }

            .compact-date-range-picker-popup .ant-picker-header {
              padding: 4px 8px;
            }

            .compact-date-range-picker-popup .ant-picker-body {
              padding: 4px;
            }

            .compact-date-range-picker-popup .ant-picker-content th {
              height: 24px;
              padding-bottom: 2px;
            }

            .compact-date-range-picker-popup .ant-picker-cell {
              padding: 1px 0;
            }

            .compact-date-range-picker-popup .ant-picker-cell-inner {
              min-width: 24px;
              height: 24px;
              line-height: 24px;
            }

            .compact-date-range-picker-popup .ant-picker-time-panel-column > li {
              height: 24px;
              line-height: 24px;
            }

            .compact-date-range-picker-popup .ant-picker-footer {
              padding: 2px 6px 4px;
            }
          }
        `}
      </style>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: coreTheme.colorPrimary,
            borderRadius: coreTheme.borderRadius,
          },
          components: {
            Button: {
              colorPrimary: coreTheme.colorPrimary,
              borderRadius: 8,
              borderRadiusSM: 8,
              borderRadiusLG: 8,
            },
            Descriptions: {
              labelColor: '#000',
              contentColor: '#000',
            },
            Form: {
              labelColor: '#000',
            },

            Input: {
              colorText: '#000',
              colorTextDisabled: '#000',
            },

            Select: {
              colorText: '#000',
              colorTextDisabled: '#000',
            },

            DatePicker: {
              colorText: '#000',
              colorTextDisabled: '#000',
            },
          },
        }}
      >
        {children}
      </ConfigProvider>
    </>
  );
}
